import {AnyAction, Dispatch} from '@modifi/redux'
import {createSelector} from 'reselect'

import {rootSelector} from '../../redux/root-selector'

type CurrentStepState = {
  currentStep: number | null
}

const ACTION_SET_CURRENT_STEP = 'pages/seller-trade-partner/SET_CURRENT_STEP'
const ACTION_CLEAR_CURRENT_STEP = 'pages/beneficial-owners/CLEAR_CURRENT_STEP'

const initialState: CurrentStepState = {
  currentStep: null,
}

export default (state = initialState, {type, payload}: AnyAction): CurrentStepState => {
  switch (type) {
    case ACTION_SET_CURRENT_STEP: {
      const {step} = payload
      return {
        ...state,
        currentStep: step,
      }
    }
    case ACTION_CLEAR_CURRENT_STEP:
      return {
        ...state,
        currentStep: null,
      }
    default:
      return state
  }
}

export const aClearCurrentStep = (): AnyAction => ({
  type: ACTION_CLEAR_CURRENT_STEP,
})

export const aSetCurrentStep =
  (step: number) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACTION_SET_CURRENT_STEP,
      payload: {step},
    })
  }

const baseSelector = createSelector(
  rootSelector,
  root => root?.pages?.sellerTradePartners?.currentStep
)

export const selectCurrentStep = createSelector(baseSelector, subState => subState.currentStep)
